import { GoodDetailData } from '@/shop/c_shop_golden/component';
/**
 * 获取多规格页ab实验
 */
export const getMultiSkuModalABTest = (goodDetail: GoodDetailData) => {
  const expGroupKey = 'multi_spec_page_ab_test_exp1';
  let expKey;
  goodDetail?.extraInfo?.expInfoList?.forEach((item) => {
    if (item.groupKey === expGroupKey) {
      expKey = item.expKey;
    }
  });
  if (expKey === 'A' || expKey === 'B') {
    return true;
  }
  return false;
};
